<template>
  <div>
    <v-card
      elevation="5"
    >
      <v-toolbar
        color="primaryLight"
        dark
        dense
        style="z-index: 2;"
      >
        <v-toolbar-title>Medios</v-toolbar-title>

        <v-spacer />

        <v-tooltip
          bottom
        >
          <template
            #activator="{ on, attrs }"
          >
            <v-btn
              fab
              small
              v-bind="attrs"
              color="secondary"
              :disabled="disabledByRol || isIncendioFinalizado"
              v-on="on"
              @click="showDialogAddMedios = true"
            >
              <v-icon
                color="primary"
              >
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <span>Añadir medios</span>
        </v-tooltip>

        <v-tooltip
          bottom
        >
          <template
            #activator="{ on, attrs }"
          >
            <v-btn
              fab
              small
              v-bind="attrs"
              color="secondary"
              class="ml-2"
              :disabled="disabledByRol || isIncendioFinalizado"
              v-on="on"
              @click="showDialogEditSectores = true"
            >
              <v-icon
                color="primary"
              >
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Editar sectores</span>
        </v-tooltip>
      </v-toolbar>

      <v-card-text
        class="pa-0"
      >
        <!-- Filtro por estado -->
        <v-tabs
          v-model="filtroEstadoSelected"
          slider-color="secondary"
          grow
        >
          <v-tab
            v-for="(estado, n) in estadosRecursos"
            :key="estado.value"
            :value="estado.value"
          >
            <v-icon
              class="mr-1"
            >
              {{ estado.icon }}
            </v-icon>
            <label
              class="caption pb-3 pr-1"
            >
              {{ numActivos[n] }}
            </label>
            {{ (estado.label) }}
          </v-tab>
        </v-tabs>
        <v-tabs
          v-model="categoriaSelected"
          slider-color="secondary"
          grow
        >
          <v-tab
            v-for="(medio, n) in categoriasMedios"
            :key="medio.CATEGORIA"
            ripple
          >
            <v-icon>{{ medio.ICONO }}</v-icon>
            <label
              class="caption pb-3 pr-1"
            >
              {{ numMedios[n] }}
            </label>
            {{ medio.CATEGORIA }}
          </v-tab>
        </v-tabs>

        <v-skeleton-loader
          v-if="loading"
          type="table-thead, table-row@3"
          class="mx-6"
        />
        <vx-medios-table
          v-else-if="mediosTable"
          :medios="mediosTable"
          :loading="loading"
          @editMedioIncendio="editMedioIncendio"
          @setFecha="setFecha"
        />
      </v-card-text>
    </v-card>

    <!-- Diálogos -->
    <vx-dialog-add-medios
      :show="showDialogAddMedios"
      :id-incendio="idIncendio"
      @aceptar="acceptAddMediosIncendio"
      @cancelar="cancelAddMediosIncendio"
    />
    <vx-dialog-edit-medio
      :show="showDialogEditMedio"
      :id-incendio="idIncendio"
      :medio-sector="medioEdit"
      @aceptar="acceptEditMedioIncendio"
      @cancelar="cancelEditMedioIncendio"
      @deleteMedioIncendio="deleteMedioIncendio"
    />
    <vx-change-medio-sector-table
      :show="showDialogEditSectores"
      :medios="mediosTable"
      :id-incendio="idIncendio"
      @acceptEditSectorIncendio="acceptEditSectorIncendio"
      @close="closeChangeMedioSector"
    />
  </div>
</template>

<script>
import constant from '../../../helpers/constants'

import MediosTable from './MediosTable'
import DialogAddMedios from './DialogAddMedios'
import DialogEditMedio from './DialogEditMedio'
import ChangeMedioSectorTable from './ChangeMedioSectorTable'

export default {
  components: {
    'vx-medios-table': MediosTable,
    'vx-dialog-add-medios': DialogAddMedios,
    'vx-dialog-edit-medio': DialogEditMedio,
    'vx-change-medio-sector-table': ChangeMedioSectorTable
  },

  props: {
    sectoresSelected: Array,
    idIncendio: String,
    loading: Boolean
  },

  data: () => ({
    numMedios: [],
    categoriasMedios: [],

    categoriaSelected: 0,

    showDialogAddMedios: false,
    showDialogEditMedio: false,
    showDialogEditSectores: false,

    medioEdit: {},
    numActivos: [],
    filtroEstadoSelected: 0,
    estadosRecursos: [
      { label: 'TODOS', value: 0, icon: 'mdi-check-all' },
      { label: 'ACTiVOS', value: 1, icon: 'mdi-eye' },
      { label: 'INACTIVOS', value: 2, icon: 'mdi-eye-off' }
    ]
  }),

  computed: {
    incendio() {
      return this.$store.getters['incendio/getIncendioByID'](this.idIncendio)
    },

    isIncendioFinalizado() {
      return this.$store.getters['incendio/isIncendioFinalizado'](this.idIncendio)
    },

    medios() {
      return this.$store.getters['medio/medios']
    },

    sectores() {
      return this.incendio?.SECTORES || []
    },

    selectedSectorIdxs() {
      if (this.sectoresSelected.length) {
        return this.sectoresSelected
      }
      return this.sectores.map((_, idx) => idx)
    },

    mediosTable() {
      if (this.loading || !this.incendio) return []

      this.countNumMedios()

      const categoria = this.categoriasMedios?.[this.categoriaSelected]?.CATEGORIA
      let result = []

      for (const sectorIdx of this.selectedSectorIdxs) {
        const sector = this.sectores[sectorIdx]
        if (!sector || !Array.isArray(sector.MEDIOS)) continue

        for (const medioSector of sector.MEDIOS) {
          if (!medioSector.FECHA_ALARMADO) continue

          const medio = this.medios.find(m => m.ID_MEDIO === medioSector.ID_MEDIO)
          if (!medio) continue
          if (this.categoriaSelected !== 0 && medio.CATEGORIA !== categoria) continue

          result.push({
            ID_INCENDIO: this.idIncendio,
            ID_SECTOR: medioSector.ID_SECTOR,
            SECTOR: sector.SECTOR,
            ID_MEDIO_SECTOR: medioSector.ID_MEDIO_SECTOR,
            ID_MEDIO: medio.ID_MEDIO,
            MEDIO: medio.MEDIO,
            ESTADO: medio.ESTADO,
            FECHA_ALARMADO: medioSector.FECHA_ALARMADO,
            FECHA_EN_CAMINO: medioSector.FECHA_EN_CAMINO,
            FECHA_EN_LUGAR: medioSector.FECHA_EN_LUGAR,
            FECHA_FINALIZADO: medioSector.FECHA_FINALIZADO,
            FECHA_LLEGADA_GEOFENCING: medioSector.FECHA_LLEGADA_GEOFENCING,
            FECHA_FIN_DESCANSO: medioSector.FECHA_FIN_DESCANSO,
            NUM_COMPONENTES: medioSector.NUM_COMPONENTES,
            PLANIFICACION: medioSector.PLANIFICACION,
            FECHAS_ORIGEN: medioSector.FECHAS_ORIGEN
          })
        }
      }

      switch (this.filtroEstadoSelected) {
        case 1:
          result = result.filter(x => !x.FECHA_FINALIZADO)
          break
        case 2:
          result = result.filter(x => x.FECHA_FINALIZADO)
          break
      }

      return result
    },

    disabledByRol() {
      // Deshabilita funciones dependiendo del rol
      return !this.$store.getters['usuario/isCurrentUsuarioAdmin']
    }
  },

  watch: {
    idIncendio() {
      this.categoriaSelected = 0
    }
  },

  created() {
    this.categoriasMedios = [
      constant.allMedios,
      ...structuredClone(constant.categoriasMedios)
    ]
  },

  methods: {
    countNumMedios() {
      const counts = { Recurso: 0, Terrestre: 0, Aereo: 0 }

      let total = 0
      let activos = 0
      let inactivos = 0

      const sectorIdxs = this.selectedSectorIdxs || []

      for (const idx of sectorIdxs) {
        const sector = this.sectores?.[idx]
        if (!sector) continue

        for (const medioSector of sector.MEDIOS) {
          if (!medioSector?.FECHA_ALARMADO) continue

          // Conteo activos/inactivos
          total++
          !medioSector.FECHA_FINALIZADO ? activos++ : inactivos++

          // Conteo por categoría
          const medio = this.medios.find(m => m.ID_MEDIO === medioSector.ID_MEDIO)
          if (!medio) continue

          const cat = medio.CATEGORIA === 'Aéreo' ? 'Aereo' : (medio.CATEGORIA || '')
          if (!counts[cat]) counts[cat] = 0
          counts[cat]++
        }
      }

      this.numMedios = [
        total,
        counts.Recurso || 0,
        counts.Terrestre || 0,
        counts.Aereo || 0
      ]

      this.numActivos = [total, activos, inactivos]
    },

    // Añadir medio
    acceptAddMediosIncendio(medios) {
      this.showDialogAddMedios = false
      this.$store.dispatch('incendio/addMediosIncendio', medios)
    },

    cancelAddMediosIncendio() {
      this.showDialogAddMedios = false
    },

    // Click en boton reloj
    setFecha(medio) {
      this.$store.dispatch('incendio/editMedioIncendio', medio)
    },

    // Editar medio
    editMedioIncendio(medio) {
      this.showDialogEditMedio = true
      this.medioEdit = medio
    },

    acceptEditMedioIncendio(medioEdit) {
      this.showDialogEditMedio = false
      this.$store.dispatch('incendio/editMedioIncendio', medioEdit)
      this.medioEdit = {}
    },

    cancelEditMedioIncendio() {
      this.showDialogEditMedio = false
      this.medioEdit = {}
    },

    // Borrar medio
    deleteMedioIncendio(medioDelete) {
      this.showDialogEditMedio = false
      this.medioEdit = {}
      this.$store.dispatch('incendio/deleteMedioIncendio', medioDelete)
    },

    // Editar sectores
    editSectorIncendio(medio) {
      this.showDialogEditMedioSector = true
      this.medioEdit = medio
    },
    acceptEditSectorIncendio(medioEdit) {
      this.showDialogEditMedioSector = false
      this.$store.dispatch('incendio/editMedioIncendio', medioEdit)
      this.medioEdit = {}
    },
    closeChangeMedioSector() {
      this.showDialogEditSectores = false
      this.medioEdit = {}
    }
  }
}
</script>

<style scoped>
</style>
